module.exports = __webpack_public_path__ + "static/media/combined-shape@3x.0eddd566.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/combined-shape@3x.png
// module id = 14
// module chunks = 19